<template>
  <div id="list">
    <ListItem
        color="#004f9c"
        leftIcon="images/ETC/jsyh.png"
        title="建设银行"
        rightIcon="images/ETC/jsyh_p.png"
        imgUrl="images/ETC/jsyhShow.jpg"
    />
    <ListItem
        color="#c42b25"
        leftIcon="images/ETC/gsyh.png"
        title="工商银行"
        rightIcon="images/ETC/gsyh_p.png"
        imgUrl="images/ETC/gsyhShow.jpg"
    />
  </div>
</template>

<script>
  import ListItem from './listItem'

  export default {
    name: "index",
    components: {
      ListItem,
    },
  }
</script>

<style scoped>

</style>
